export const PAGE_PRESETS = {
  A4: { width: 794, height: 1123 },
  A5: { width: 559, height: 794 },
  thermal_58mm: { width: 220, height: 900 },
  thermal_80mm: { width: 302, height: 900 },
  custom: { width: 794, height: 1123 },
};

export const VARIABLE_SAMPLE_VALUES = {
  voucher_code: 'AB60',
  username: 'AB60',
  password: 'AB60',
  primary_code: 'AB60',
  is_same_credential: true,
  show_single_code: true,
  profile_name: 'Hotspot 24 Jam',
  selling_price: '9000',
  session_duration: '24 jam',
  quota_value: '5 GB',
  support_contact: '0812-3456-7890',
  qr_login_url: 'https://ktconline.id/login/AB60',
  company_name: 'Kedai Teknologi Celebes',
};

export const BLOCK_LIBRARY = [
  { type: 'background_layer', label: 'Background Layer', width: 560, height: 260, styleDefaults: { fillColor: '#0ea5e9', opacity: 0.15 } },
  { type: 'rectangle', label: 'Rectangle', width: 260, height: 120, styleDefaults: { fillColor: '#0ea5e9', opacity: 0.2, borderColor: '#0284c7', borderWidth: 1 } },
  { type: 'rounded_box', label: 'Rounded Box', width: 260, height: 120, styleDefaults: { fillColor: '#0ea5e9', opacity: 0.2, borderColor: '#0284c7', borderWidth: 1, borderRadius: 16 } },
  { type: 'line', label: 'Line', width: 240, height: 4, styleDefaults: { fillColor: '#0f172a', opacity: 1 } },
  { type: 'circle_badge', label: 'Circle Badge', width: 84, height: 84, text: 'HOT', styleDefaults: { fillColor: '#ef4444', color: '#ffffff', fontWeight: 700 } },
  { type: 'triangle', label: 'Triangle', width: 120, height: 120, direction: 'right', styleDefaults: { fillColor: '#0ea5e9', opacity: 0.85 } },
  { type: 'polygon_accent', label: 'Polygon Accent', width: 180, height: 80, styleDefaults: { fillColor: '#0284c7', opacity: 0.75 } },
  { type: 'footer_bar', label: 'Footer Bar', width: 520, height: 44, text: 'Hotspot Voucher', styleDefaults: { fillColor: '#0f172a', color: '#ffffff', opacity: 0.9 } },
  { type: 'price_badge', label: 'Price Badge', width: 140, height: 54, text: 'Rp 9.000', styleDefaults: { fillColor: '#f59e0b', color: '#111827', borderRadius: 14, fontWeight: 700 } },
  { type: 'logo', label: 'Logo/Image', width: 140, height: 70 },
  { type: 'text', label: 'Text', width: 220, height: 40, text: 'Judul Voucher' },
  { type: 'variable_text', label: 'Variable Text', width: 220, height: 34, binding: 'voucher_code' },
  { type: 'voucher_code', label: 'Voucher Code', width: 220, height: 38, binding: 'voucher_code' },
  { type: 'username', label: 'Username', width: 220, height: 30, binding: 'username' },
  { type: 'password', label: 'Password', width: 220, height: 30, binding: 'password' },
  { type: 'profile_name', label: 'Profile Name', width: 220, height: 30, binding: 'profile_name' },
  { type: 'price', label: 'Price', width: 200, height: 30, binding: 'selling_price' },
  { type: 'duration', label: 'Duration', width: 200, height: 30, binding: 'session_duration' },
  { type: 'quota', label: 'Quota', width: 200, height: 30, binding: 'quota_value' },
  { type: 'support_contact', label: 'Support Contact', width: 220, height: 30, binding: 'support_contact' },
  { type: 'adaptive_credential', label: 'Adaptive Credential', width: 280, height: 54 },
  { type: 'qr_code', label: 'QR Code', width: 140, height: 140, binding: 'qr_login_url' },
  { type: 'divider', label: 'Divider', width: 260, height: 8 },
  { type: 'box', label: 'Box', width: 260, height: 120 },
  { type: 'custom_text', label: 'Custom Text', width: 220, height: 44, text: 'Catatan tambahan' },
  { type: 'price_badge', label: 'Preset: Price Corner', width: 150, height: 56, text: 'Rp 9.000', styleDefaults: { fillColor: '#f59e0b', color: '#111827', borderRadius: 18, fontWeight: 700 } },
  { type: 'polygon_accent', label: 'Preset: Diagonal Ribbon', width: 200, height: 70, styleDefaults: { fillColor: '#0ea5e9', opacity: 0.8 } },
  { type: 'footer_bar', label: 'Preset: Footer Strip', width: 540, height: 44, text: 'Kedai Teknologi Celebes', styleDefaults: { fillColor: '#0f172a', color: '#ffffff', opacity: 0.9 } },
  { type: 'rounded_box', label: 'Preset: QR Panel', width: 170, height: 170, styleDefaults: { fillColor: '#ffffff', borderColor: '#0f172a', borderWidth: 1, borderRadius: 12, opacity: 1 } },
];

export const DEFAULT_LAYOUT = {
  version: 2,
  page: {
    page_size: 'A4',
    orientation: 'portrait',
    width: 794,
    height: 1123,
    grid_enabled: true,
    snap_enabled: true,
    grid_size: 8,
    zoom: 1,
  },
  styles: {
    background_color: '#ffffff',
    text_color: '#111827',
    font_family: 'Arial, sans-serif',
  },
  blocks: [],
};

const toNumber = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};

const normalizeStyle = (style = {}) => ({
  fontSize: toNumber(style.fontSize ?? style.font_size, 14),
  fontWeight: toNumber(style.fontWeight ?? style.font_weight, 500),
  color: style.color || '#111827',
  fillColor: style.fillColor ?? style.fill_color ?? style.backgroundColor ?? style.background ?? 'transparent',
  backgroundColor: style.backgroundColor ?? style.background ?? 'transparent',
  borderColor: style.borderColor || 'transparent',
  borderWidth: toNumber(style.borderWidth ?? style.border_width, 1),
  borderRadius: toNumber(style.borderRadius ?? style.border_radius, 0),
  opacity: toNumber(style.opacity, 1),
  textAlign: style.textAlign ?? style.text_align ?? 'left',
});

export const normalizeBuilderState = (input) => {
  const raw = input && typeof input === 'object' ? input : {};
  const pageRaw = raw.page && typeof raw.page === 'object' ? raw.page : {};
  const pageSize = pageRaw.page_size || pageRaw.size || 'A4';
  const orientation = pageRaw.orientation || 'portrait';
  const preset = PAGE_PRESETS[pageSize] || PAGE_PRESETS.A4;
  const width = toNumber(pageRaw.width, orientation === 'landscape' ? preset.height : preset.width);
  const height = toNumber(pageRaw.height, orientation === 'landscape' ? preset.width : preset.height);

  const blocksRaw = Array.isArray(raw.blocks) ? raw.blocks : [];
  const blocks = blocksRaw
    .filter((b) => b && typeof b === 'object')
    .map((b, idx) => ({
      id: String(b.id || `block-${Date.now()}-${idx}`),
      type: b.type || 'text',
      src: String(b.src || ''),
      binding: b.binding || '',
      text: b.text || '',
      x: toNumber(b.x, 24 + idx * 12),
      y: toNumber(b.y, 24 + idx * 12),
      width: toNumber(b.width ?? b.w, 220),
      height: toNumber(b.height ?? b.h, 36),
      z_index: toNumber(b.z_index ?? b.z, idx + 1),
      locked: Boolean(b.locked),
      visible: b.visible === undefined ? true : Boolean(b.visible),
      visible_when: String(b.visible_when || ''),
      direction: String(b.direction || 'right'),
      style: normalizeStyle(b.style || {}),
    }));

  return {
    version: toNumber(raw.version, 2),
    page: {
      page_size: pageSize,
      orientation,
      width,
      height,
      grid_enabled: pageRaw.grid_enabled ?? pageRaw.grid_snap ?? true,
      snap_enabled: pageRaw.snap_enabled ?? pageRaw.grid_snap ?? true,
      grid_size: toNumber(pageRaw.grid_size, 8),
      zoom: toNumber(pageRaw.zoom, 1),
    },
    styles: {
      background_color: raw.styles?.background_color || '#ffffff',
      text_color: raw.styles?.text_color || '#111827',
      font_family: raw.styles?.font_family || 'Arial, sans-serif',
    },
    blocks,
  };
};

export const createBlock = (item, state, x = 24, y = 24) => ({
  id: `block-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  type: item.type,
  src: '',
  binding: item.binding || '',
  text: item.text || '',
  x,
  y,
  width: item.width || 220,
  height: item.height || 36,
  z_index: (state.blocks.reduce((m, b) => Math.max(m, Number(b.z_index || 0)), 0) || 0) + 1,
  locked: false,
  visible: true,
  visible_when: '',
  direction: item.direction || 'right',
  style: {
    fontSize: 14,
    fontWeight: 500,
    color: '#111827',
    fillColor: item.styleDefaults?.fillColor ?? 'transparent',
    backgroundColor: 'transparent',
    borderColor: item.styleDefaults?.borderColor ?? 'transparent',
    borderWidth: item.styleDefaults?.borderWidth ?? 1,
    borderRadius: item.styleDefaults?.borderRadius ?? 0,
    opacity: item.styleDefaults?.opacity ?? 1,
    textAlign: 'left',
    ...item.styleDefaults,
  },
});

export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const snapValue = (value, enabled, gridSize) => {
  if (!enabled) return value;
  const unit = Math.max(1, Number(gridSize || 8));
  return Math.round(value / unit) * unit;
};

export const getBlockDisplayText = (block) => {
  if (block.type === 'adaptive_credential') {
    const same = Boolean(VARIABLE_SAMPLE_VALUES.is_same_credential);
    return same
      ? `Kode: ${VARIABLE_SAMPLE_VALUES.primary_code}`
      : `Username: ${VARIABLE_SAMPLE_VALUES.username}\nPassword: ${VARIABLE_SAMPLE_VALUES.password}`;
  }
  if (block.binding) return VARIABLE_SAMPLE_VALUES[block.binding] || `{{ ${block.binding} }}`;
  if (block.type === 'variable_text') return VARIABLE_SAMPLE_VALUES.voucher_code;
  if (block.type === 'voucher_code') return VARIABLE_SAMPLE_VALUES.voucher_code;
  if (block.type === 'username') return VARIABLE_SAMPLE_VALUES.username;
  if (block.type === 'password') return VARIABLE_SAMPLE_VALUES.password;
  if (block.type === 'profile_name') return VARIABLE_SAMPLE_VALUES.profile_name;
  if (block.type === 'price') return VARIABLE_SAMPLE_VALUES.selling_price;
  if (block.type === 'duration') return VARIABLE_SAMPLE_VALUES.session_duration;
  if (block.type === 'quota') return VARIABLE_SAMPLE_VALUES.quota_value;
  if (block.type === 'support_contact') return VARIABLE_SAMPLE_VALUES.support_contact;
  if (block.type === 'qr_code') return 'QR';
  if (block.type === 'price_badge') return block.text || 'Rp 9.000';
  if (block.type === 'circle_badge') return block.text || 'HOT';
  if (block.type === 'divider') return '';
  if (block.type === 'box') return '';
  if (['background_layer', 'rectangle', 'rounded_box', 'line', 'triangle', 'polygon_accent', 'footer_bar'].includes(block.type)) {
    return block.text || '';
  }
  return block.text || block.type;
};
